import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "upcoming-actions",
  ref: "upcomingActionsRef"
}
const _hoisted_3 = {
  key: 0,
  class: "card card-upcoming"
}
const _hoisted_4 = { class: "action-controls" }
const _hoisted_5 = {
  key: 1,
  class: "card card-upcoming"
}
const _hoisted_6 = { class: "action-controls" }
const _hoisted_7 = { class: "action-controls-info" }
const _hoisted_8 = {
  key: 0,
  class: "card card-upcoming"
}
const _hoisted_9 = { class: "action-controls" }
const _hoisted_10 = { class: "action-controls-info" }
const _hoisted_11 = {
  key: 1,
  class: "card card-upcoming"
}
const _hoisted_12 = { class: "action-controls" }
const _hoisted_13 = { class: "button primary default action-btn upload-btn" }
const _hoisted_14 = ["accept"]
const _hoisted_15 = {
  key: 2,
  class: "card card-upcoming"
}
const _hoisted_16 = { class: "action-controls" }
const _hoisted_17 = {
  key: 0,
  class: "card card-upcoming"
}
const _hoisted_18 = { class: "action-controls" }
const _hoisted_19 = {
  key: 1,
  class: "card card-upcoming"
}
const _hoisted_20 = { class: "action-controls" }
const _hoisted_21 = { class: "action-controls-info" }
const _hoisted_22 = {
  key: 1,
  class: "card card-upcoming"
}
const _hoisted_23 = { class: "action-controls" }
const _hoisted_24 = {
  key: 0,
  class: "action-controls-info"
}
const _hoisted_25 = {
  key: 0,
  class: "card card-upcoming"
}
const _hoisted_26 = { class: "action-controls" }
const _hoisted_27 = {
  key: 1,
  class: "card card-upcoming"
}
const _hoisted_28 = { class: "action-controls" }
const _hoisted_29 = { class: "action-controls-info" }
const _hoisted_30 = {
  key: 2,
  class: "card card-upcoming"
}
const _hoisted_31 = { class: "action-controls" }
const _hoisted_32 = { class: "action-controls-info" }
const _hoisted_33 = {
  key: 5,
  class: "card card-upcoming"
}
const _hoisted_34 = {
  key: 1,
  class: "no-actions"
}
const _hoisted_35 = {
  key: 2,
  class: "past-actions"
}
const _hoisted_36 = {
  key: 0,
  class: "card-past-action transparent"
}
const _hoisted_37 = { class: "action-title-block" }
const _hoisted_38 = { class: "action-name" }
const _hoisted_39 = { class: "action-details-block" }
const _hoisted_40 = { class: "action-details" }
const _hoisted_41 = { class: "action-details" }
const _hoisted_42 = {
  key: 1,
  class: "card-past-action transparent"
}
const _hoisted_43 = { class: "action-title-block" }
const _hoisted_44 = { class: "action-name" }
const _hoisted_45 = { class: "action-details-block" }
const _hoisted_46 = { class: "action-details" }
const _hoisted_47 = { class: "action-details" }
const _hoisted_48 = {
  key: 2,
  class: "card-past-action transparent"
}
const _hoisted_49 = { class: "action-title-block" }
const _hoisted_50 = { class: "action-name" }
const _hoisted_51 = {
  key: 3,
  class: "card card-past-action transparent"
}
const _hoisted_52 = { class: "action-title-block" }
const _hoisted_53 = { class: "action-name" }
const _hoisted_54 = { class: "action-name" }
const _hoisted_55 = { class: "action-details-block" }
const _hoisted_56 = { class: "action-details" }
const _hoisted_57 = { class: "action-details" }
const _hoisted_58 = {
  key: 1,
  class: "card card-past-action transparent"
}
const _hoisted_59 = { class: "action-details-block" }
const _hoisted_60 = { class: "action-details" }
const _hoisted_61 = {
  key: 3,
  class: "no-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.lot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "block-title" }, "UPCOMING", -1)),
        ($setup.canManageLot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($props.lot.status === $setup.LotStatus.NOT_RELEASED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "action-info" }, [
                      _createElementVNode("div", { class: "upcoming-icon up-icon" }),
                      _createElementVNode("div", { class: "action-name" }, "Release Lot")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "button primary default action-btn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showReleaseModal = true))
                      }, "Release")
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.AVAILABLE && $props.eois && $props.eois.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "action-info" }, [
                      _createElementVNode("div", { class: "upcoming-icon folder-icon" }),
                      _createElementVNode("div", { class: "action-name" }, "Review Contract information forms")
                    ], -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString($props.eois.length) + " Requests", 1),
                      _createElementVNode("button", {
                        class: "button primary default action-btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab('requests')))
                      }, "Review")
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.EOI)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (!$props.lot.eoiId?.pdfLink)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "action-info" }, [
                            _createElementVNode("div", { class: "upcoming-icon file-icon" }),
                            _createElementVNode("div", { class: "action-name" }, "Generate Contract form")
                          ], -1)),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.getFirstLastName($props.lot.eoiId?.buyersData?.firstBuyer)), 1),
                            _createElementVNode("button", {
                              class: "button primary default action-btn",
                              onClick: $setup.generateContract
                            }, "Generate")
                          ])
                        ]))
                      : (!$props.lot.eoiId?.contractDocuments?.length && !$setup.isSkipUploadContract)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "action-info" }, [
                              _createElementVNode("div", { class: "upcoming-icon up-icon" }),
                              _createElementVNode("div", { class: "action-name" }, "Upload executed contract")
                            ], -1)),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("button", {
                                class: "button primary outlined default action-btn",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isSkipUploadContract = true))
                              }, "Skip"),
                              _createElementVNode("label", _hoisted_13, [
                                _cache[20] || (_cache[20] = _createTextVNode("Upload", -1)),
                                _createElementVNode("input", {
                                  type: "file",
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.uploadContract($event))),
                                  accept: $setup.documentTypes
                                }, null, 40, _hoisted_14)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "action-info" }, [
                              _createElementVNode("div", { class: "upcoming-icon check-icon" }),
                              _createElementVNode("div", { class: "action-name" }, "Mark as Contract Executed")
                            ], -1)),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("button", {
                                class: "button primary default action-btn",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeLotStatus($setup.LotStatus.CONTRACT_EXECUTED)))
                              }, "Mark as Contract Executed")
                            ])
                          ]))
                  ], 64))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.CONTRACT_EXECUTED)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    ($props.lot.eoiId?.contractConditions?.subjectToFinance)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!$props.lot?.financeDueDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "action-info" }, [
                                  _createElementVNode("div", { class: "upcoming-icon calendar-blank-icon" }),
                                  _createElementVNode("div", { class: "action-name" }, "Add Finance due date")
                                ], -1)),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("button", {
                                    class: "button primary default action-btn",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showChangeDateModal = true))
                                  }, "Add")
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          ($props.lot.financeDueDate && $setup.canChangeLotDate($props.lot.financeDueDate))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "action-info" }, [
                                  _createElementVNode("div", { class: "upcoming-icon calendar-plus-icon" }),
                                  _createElementVNode("div", { class: "action-name" }, "Extend Finance due date")
                                ], -1)),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, "Finance due date: " + _toDisplayString($setup.formatDate($props.lot.financeDueDate)), 1),
                                  _createElementVNode("button", {
                                    class: "button primary default action-btn",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showChangeDateModal = true))
                                  }, "Extend")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (($props.lot.eoiId && !$props.lot.eoiId?.contractConditions?.subjectToFinance) || ($props.lot.financeDueDate && $setup.canChangeLotDate($props.lot.financeDueDate)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "action-info" }, [
                            _createElementVNode("div", { class: "upcoming-icon check-icon" }),
                            _createElementVNode("div", { class: "action-name" }, "Mark as Unconditional")
                          ], -1)),
                          _createElementVNode("div", _hoisted_23, [
                            ($props.lot.financeDueDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Finance due date: " + _toDisplayString($setup.formatDate($props.lot.financeDueDate)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "button primary default action-btn",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.changeLotStatus($setup.LotStatus.UNCONDITIONAL)))
                            }, "Mark as Unconditional")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              ($props.lot.status === $setup.LotStatus.UNCONDITIONAL)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (!$props.lot.settlementDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "action-info" }, [
                            _createElementVNode("div", { class: "upcoming-icon calendar-icon" }),
                            _createElementVNode("div", { class: "action-name" }, "Add Settlement date")
                          ], -1)),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                              class: "button primary default action-btn",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showChangeDateModal = true))
                            }, "Add")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($props.lot.settlementDate && $setup.canChangeLotDate($props.lot.settlementDate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "action-info" }, [
                            _createElementVNode("div", { class: "upcoming-icon calendar-plus-icon" }),
                            _createElementVNode("div", { class: "action-name" }, "Extend Settlement date")
                          ], -1)),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, "Settlement date: " + _toDisplayString($setup.formatDate($props.lot.settlementDate)), 1),
                            _createElementVNode("button", {
                              class: "button primary default action-btn",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.showChangeDateModal = true))
                            }, "Extend")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($props.lot.settlementDate && $setup.canChangeLotDate($props.lot.settlementDate))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "action-info" }, [
                            _createElementVNode("div", { class: "upcoming-icon check-icon" }),
                            _createElementVNode("div", { class: "action-name" }, "Mark as Settled")
                          ], -1)),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, "Settlement date: " + _toDisplayString($setup.formatDate($props.lot.settlementDate)), 1),
                            _createElementVNode("button", {
                              class: "button primary default action-btn",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showConfirmActionModal = 'markSettled'))
                            }, "Mark as Settled")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              ($props.lot?.eoiId?.status === $setup.EoiStatus.TRANSACTION_ERROR)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "action-info" }, [
                      _createElementVNode("div", { class: "upcoming-icon file-icon" }),
                      _createElementVNode("div", { class: "action-name" }, "Initial deposit failed. Generate new payment link")
                    ], -1)),
                    _createElementVNode("div", { class: "action-controls" }, [
                      _createElementVNode("button", {
                        class: "button default copy",
                        onClick: $setup.getPaymentUrl
                      }, "Copy link")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        (!$setup.hasUpcomingActions || !$setup.canManageLot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, "You have no upcoming actions"))
          : _createCommentVNode("", true),
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "block-title" }, "PAST", -1)),
        ($setup.pastActions?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pastActions, (action) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (action.action === 'changed')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.filterPastActions(action.changedParams), (field) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (field === 'offlineSale' && (action.newValues?.offlineSale?.offlineBuyerData?.fullName || action.newValues?.offlineSale?.offlineBuyerData?.fullName === ''))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "action-name" }, "Buyer Name", -1)),
                                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "to-icon" }, null, -1)),
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(action.newValues?.offlineSale?.offlineBuyerData?.fullName || "-"), 1)
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString($setup.formatDate(action.createdAt, "D MMM YYYY, hh:mm A")), 1),
                                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "action-delimiter" }, null, -1)),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(action.producedBy), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (field === 'offlineSale' && (action.newValues?.offlineSale?.offlineDeposit || action.newValues?.offlineSale?.offlineDeposit === 0))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "action-name" }, "Deposit changed", -1)),
                                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "to-icon" }, null, -1)),
                                  _createElementVNode("div", _hoisted_44, _toDisplayString($setup.formatStripePrice(action.newValues?.offlineSale?.offlineDeposit)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, _toDisplayString($setup.formatDate(action.createdAt, "D MMM YYYY, hh:mm A")), 1),
                                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "action-delimiter" }, null, -1)),
                                  _createElementVNode("div", _hoisted_47, _toDisplayString(action.producedBy), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (field === 'offlineSale' && action.newValues?.offlineSale?.salePhase)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "action-name" }, "Sale phase", -1)),
                                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "to-icon" }, null, -1)),
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(action.newValues?.offlineSale?.salePhase === $setup.LotStatus.EOI? $setup.getPreContractOrHoldStatus
: action.newValues?.offlineSale?.salePhase), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (field !== 'offlineSale')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(`${$setup.formatField(field, action)} ${field === "buyerId" ? "" : "changed"}`), 1),
                                  (action.newValues)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "to-icon" }, null, -1)),
                                        _createElementVNode("div", _hoisted_54, _toDisplayString($setup.normalizedChangedValue(field, action.newValues[field]) === $setup.LotStatus.EOI
? $setup.getPreContractOrHoldStatus
: $setup.normalizedChangedValue(field, action.newValues[field])), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, _toDisplayString($setup.formatDate(action.createdAt, "D MMM YYYY, hh:mm A")), 1),
                                  _cache[39] || (_cache[39] = _createElementVNode("div", { class: "action-delimiter" }, null, -1)),
                                  _createElementVNode("div", _hoisted_57, _toDisplayString(action.producedBy), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _cache[42] || (_cache[42] = _createElementVNode("div", { class: "action-title-block" }, [
                          _createElementVNode("div", { class: "action-name" }, "Lot created")
                        ], -1)),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, _toDisplayString($setup.formatDate(action.createdAt, "D MMM YYYY, hh:mm A")), 1),
                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "action-delimiter" }, null, -1)),
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "action-details" }, "Admin", -1))
                        ])
                      ]))
                ], 64))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_61, "You have no past actions")),
        _createVNode($setup["EditLotModal"], {
          isOpen: $setup.showChangeDateModal,
          lot: $props.lot,
          onClose: _cache[11] || (_cache[11] = ($event: any) => ($setup.showChangeDateModal = false)),
          onUpdate: $setup.updateLot,
          onLoading: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('loading')))
        }, null, 8, ["isOpen", "lot"]),
        _createVNode($setup["LotDetailsConfirmModal"], {
          onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.showConfirmActionModal = '')),
          onConfirm: $setup.updateLot,
          onLoading: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('loading'))),
          showModal: $setup.showConfirmActionModal,
          lot: $props.lot
        }, null, 8, ["showModal", "lot"]),
        _createVNode($setup["ReleaseLotsModal"], {
          onClose: _cache[15] || (_cache[15] = ($event: any) => ($setup.closeReleaseModal($event))),
          onLoading: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('loading'))),
          isOpen: $setup.showReleaseModal,
          showClose: false,
          listForUpdate: [{ id: $setup.lotId }],
          stageId: $setup.router.currentRoute.value.params.stageId
        }, null, 8, ["isOpen", "listForUpdate", "stageId"])
      ]))
    : _createCommentVNode("", true)
}